import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Performans Raporu")
  ])
], -1)
const _hoisted_3 = {
  id: "performance-report",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row g-12 mb-8" }
const _hoisted_6 = { class: "col-md-4 fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Müşteri", -1)
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "col-md-4 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Üretici", -1)
const _hoisted_11 = { class: "position-relative align-items-center" }
const _hoisted_12 = { class: "symbol symbol-20px me-4 position-absolute ms-4" }
const _hoisted_13 = { class: "symbol-label bg-secondary" }
const _hoisted_14 = { class: "svg-icon" }
const _hoisted_15 = { class: "col-md-4 fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Departman", -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Marka", -1)
const _hoisted_21 = { class: "row g-12 mb-8" }
const _hoisted_22 = { class: "col-md-4 fv-row" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Sezon", -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Şekli", -1)
const _hoisted_28 = { class: "col-md-4 fv-row" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Tarih", -1)
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Yükleme Tarihi 1", -1)
const _hoisted_34 = { class: "col-md-4 fv-row" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Yükleme Tarihi 2", -1)
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Yükleme Şekli", -1)
const _hoisted_40 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_41 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Performans Raporu")
  ])
], -1)
const _hoisted_43 = { class: "card-body" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = {
  class: "table table-striped align-middle table-row-dashed table-sm firstYear",
  style: {"border":"1.5px solid #c7c7c5","font-weight":"bold"}
}
const _hoisted_48 = {
  colspan: "4",
  class: "text-center",
  style: {"background-color":"#ededed","font-size":"16px"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px",
    style: {"font-size":"15px"}
  }, "   Aylar "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Sipariş "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Sevkiyat "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Fark   ")
], -1)
const _hoisted_50 = { class: "text-gray-600" }
const _hoisted_51 = { class: "text-end" }
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = { class: "text-end" }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "table-responsive" }
const _hoisted_60 = {
  class: "table table-striped align-middle table-row-dashed table-bordered table-sm secondYear",
  style: {"border":"1.5px solid #c7c7c5","font-weight":"bold"}
}
const _hoisted_61 = {
  colspan: "4",
  class: "text-center",
  style: {"background-color":"#ededed","font-size":"16px"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px",
    style: {"font-size":"15px"}
  }, "   Aylar "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Sipariş "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Sevkiyat "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "min-w-100px text-end",
    style: {"font-size":"15px"}
  }, " Fark   ")
], -1)
const _hoisted_63 = { class: "text-gray-600" }
const _hoisted_64 = { class: "text-end" }
const _hoisted_65 = { class: "text-end" }
const _hoisted_66 = { class: "text-end" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_68 = { class: "text-end" }
const _hoisted_69 = { class: "text-end" }
const _hoisted_70 = { class: "text-end" }
const _hoisted_71 = { class: "card-footer d-flex justify-content-start py-6 px-9" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-print",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-file-excel",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]

import { defineComponent, ref, computed } from "vue";

import Breadcrumb from "primevue/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Customer from "@/components/customers/CustomerSingleSelect.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import Years from "@/components/dates/Years.vue";
import BrandMultiSelect from "@/components/brands/BrandMultiSelect.vue";
import OrderTypeMultiSelect from "@/components/orderTypes/OrderTypeMultiSelect.vue";
import ShippingTypeMultiSelect from "@/components/shippingTypes/ShippingTypeMultiSelect.vue";
//import htmlToPaper from "@/core/plugins/VueHtmlToPaper";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue3-xlsx";
//import { components } from "@/assets/ts";
import { useRouter, useRoute } from "vue-router";
import VueHtmlToPaper from "@/core/plugins/VueHtmlToPaper";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const sheets = ref([{ name: "SheetOne", data: [{ first: 1 }] }]);
const router = useRouter();
const store = useStore();
const isActive = ref(false);
const date10 = ref();
const years: any = ref([]);
const date: any = ref();
const customers: any = ref();
const suppliers: any = ref();
const departmentIds: any = ref();
const seasonIds: any = ref();
const brandIds: any = ref([]);
const orderTypeIds: any = ref([]);
const shippingTypeIds: any = ref([]);
const shippingDateOne: any = ref();
const shippingDateTwo: any = ref();
const symbol: any = ref();
const selectedCustomer = (args) => {
  customers.value = args.value;
};
const selectedDepartment = (args) => {
  departmentIds.value = args.value;
};
const selectedSupplier = (args) => {
  suppliers.value = args.value;
};
const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};
const selectedYear = (args) => {
  date.value = args.value;
};
const selectedBrand = (args) => {
  if (args.value && args.value.length > 0) {
    brandIds.value = args.value.map((item) => item.value);
  } else {
    brandIds.value = [];
  }
};
const selectedOrderType = (args) => {
  if (args.value && args.value.length > 0) {
    orderTypeIds.value = args.value.map((item) => item.value);
  } else {
    orderTypeIds.value = [];
  }
};
const selectedShippingType = (args) => {
  if (args.value && args.value.length > 0) {
    shippingTypeIds.value = args.value.map((item) => item.value);
  } else {
    shippingTypeIds.value = [];
  }
};

const clearCustomer = () => {
  customers.value = null;
};

const performanceReportList = computed(
  () => store.state.ReportModule.performanceReport.value || []
);

const send = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  if (!date.value) {
    date.value = {
      value: new Date().getFullYear() + "-" + (new Date().getFullYear() + 1),
      name: new Date().getFullYear() + "-" + (new Date().getFullYear() + 1),
    };
  }
  var model = {
    years: date.value.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentIds.value
      ? departmentIds.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    brandIds: brandIds.value || [],
    orderTypeIds: orderTypeIds.value || [],
    shippingTypeIds: shippingTypeIds.value || [],
    shippingDateOne: shippingDateOne.value,
    shippingDateTwo: shippingDateTwo.value,
    currencyTypeId: 1,
  };
  symbol.value = model.currencyTypeId == 1 ? "€" : "$";
  store.dispatch(Actions.PERFORMANCE_REPORT_LIST, model).then(() => {
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const prints = window.document;
const exportExcel = () => {
  store
    .dispatch("PERFORMANCE_REPORT_EXPORT", {
      reportDtos: store.state.ReportModule.performanceReport.value,
    })
    .then((f) => {
      const blob = new Blob([f], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.click();
    });
};
const print = () => {
  var divContents = document.getElementsByClassName("card-body")[1].innerHTML;

  var panel = document.getElementsByClassName("card-body")[1];
  var startStr = "<!--startPrint-->";
  var printWindow = window.open("", "", "");
  printWindow?.document.write(
    "<html><head><link rel='stylesheet' href='/style/print.css'><title>Performans Raporu</title>"
  );
  //printWindow?.document.write('<style type = "text/css">');
  var table_style = "body {color:green}";
  //printWindow?.document.write(table_style);
  //printWindow?.document.write("</style>");
  printWindow?.document.write("</head><body >");
  printWindow?.document.write(panel.innerHTML);
  printWindow?.document.write("</body></html>");
  printWindow?.document.close();
  setTimeout(function () {
    printWindow?.print();
    printWindow?.close();
  }, 200);

  return false;
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(CustomerMultiSelect, { onChangeCustomer: selectedCustomer }),
                _createElementVNode("span", {
                  class: "position-absolute top-50 end-0 translate-middle-y me-2",
                  style: {"cursor":"pointer"},
                  onClick: clearCustomer
                }, "x")
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen025.svg" })
                    ])
                  ])
                ]),
                _createVNode(SupplierMultiSelect, {
                  class: "col-md-12",
                  onChangeSupplier: selectedSupplier
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(DepartmentMultiSelect, {
                    class: "col-md-12",
                    onChangeDepartment: selectedDepartment
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(BrandMultiSelect, {
                    class: "col-md-12",
                    onChangeBrand: selectedBrand
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(SeasonMultiSelect, {
                    class: "col-md-12",
                    onChangeSeason: selectedSeason
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(OrderTypeMultiSelect, {
                    class: "col-md-12",
                    onChangeOrderType: selectedOrderType
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(Years, { onChangeYear: selectedYear })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingDateOne).value = $event))
                  }, null, 512), [
                    [_vModelText, shippingDateOne.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "p-inputtext p-component p-filled col-md-12",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shippingDateTwo).value = $event))
                  }, null, 512), [
                    [_vModelText, shippingDateTwo.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(ShippingTypeMultiSelect, {
                    class: "col-md-12",
                    onChangeShippingType: selectedShippingType
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("button", {
          id: "performance-report_submit",
          ref: "submitButtonSettings",
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (send()))
        }, " Görüntüle ", 512)
      ])
    ]),
    (_unref(performanceReportList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("table", _hoisted_47, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_48, _toDisplayString(Math.min.apply(
                        Math,
                        _unref(performanceReportList).map((f) => f.year)
                      )) + " Yılı ", 1)
                      ]),
                      _hoisted_49
                    ]),
                    _createElementVNode("tbody", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(performanceReportList).filter(
                    (f) =>
                      f.year ==
                      Math.min.apply(
                        Math,
                        _unref(performanceReportList).map((f) => f.year)
                      )
                  ), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "odd",
                          key: item.name
                        }, [
                          _createElementVNode("td", null, "   " + _toDisplayString(item.month[index + 1]), 1),
                          _createElementVNode("td", _hoisted_51, _toDisplayString(parseFloat(item.performanceReport.orderPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString(parseFloat(item.performanceReport.deliveryPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(parseFloat(item.performanceReport.difference)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value) + "     ", 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _hoisted_54,
                        _createElementVNode("td", _hoisted_55, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.min.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.orderPrice)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                        _createElementVNode("td", _hoisted_56, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.min.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.deliveryPrice)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                        _createElementVNode("td", _hoisted_57, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.min.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.difference)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value) + "     ", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("table", _hoisted_60, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_61, _toDisplayString(Math.max.apply(
                        Math,
                        _unref(performanceReportList).map((f) => f.year)
                      )) + " Yılı ", 1)
                      ]),
                      _hoisted_62
                    ]),
                    _createElementVNode("tbody", _hoisted_63, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(performanceReportList).filter(
                    (f) =>
                      f.year ==
                      Math.max.apply(
                        Math,
                        _unref(performanceReportList).map((f) => f.year)
                      )
                  ), (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "odd",
                          key: item.name
                        }, [
                          _createElementVNode("td", null, "   " + _toDisplayString(item.month[index + 1]), 1),
                          _createElementVNode("td", _hoisted_64, _toDisplayString(parseFloat(item.performanceReport.orderPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                          _createElementVNode("td", _hoisted_65, _toDisplayString(parseFloat(item.performanceReport.deliveryPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(parseFloat(item.performanceReport.difference)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value) + "    ", 1)
                        ]))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _hoisted_67,
                        _createElementVNode("td", _hoisted_68, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.max.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.orderPrice)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                        _createElementVNode("td", _hoisted_69, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.max.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.deliveryPrice)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value), 1),
                        _createElementVNode("td", _hoisted_70, _toDisplayString(parseFloat(
                        _unref(performanceReportList)
                          .filter(
                            (f) =>
                              f.year ==
                              Math.max.apply(
                                Math,
                                _unref(performanceReportList).map((f) => f.year)
                              )
                          )
                          .map((f) => f.performanceReport)
                          .map((f) => f.difference)
                          .reduce(function (a, b) {
                            return a + b;
                          }, 0)
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(symbol.value == null ? "€" : symbol.value) + "   ", 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("button", {
              id: "performance-report_submit",
              ref: "submitButtonSettings",
              class: "btn btn-primary",
              onClick: print
            }, _hoisted_73, 512),
            _createElementVNode("button", {
              id: "performance-report_submit",
              ref: "submitButtonSettings",
              class: "btn btn-primary",
              style: {"margin-left":"5px"},
              onClick: exportExcel
            }, _hoisted_75, 512)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})